module.exports = "/_next/static/media/fb09d32af41ceba91b0475e9326210f4.svg";